/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CfStackResource { 
    /**
     * Resource type
     */
    resource_type?: string;
    /**
     * Logical ID
     */
    logical_resource_id?: string;
    /**
     * Physical ID
     */
    physical_resource_id?: string;
}

